import React from "react";
import OverviewSection from "@widgets/pos/orders/details/section/OverviewSection";
import LoadingScreen from "@widgets/pos/layout/LoadingScreen";

const LoadingState = () => {
    return (
        <OverviewSection>
            <LoadingScreen/>
        </OverviewSection>
    );
};

export default LoadingState;